<script>
import appConfig from "@/app.config";
import "@/assets/css/custom.css";

// import { notificationMethods } from '@/state/helpers'
import { authComputed, authMethods, userMethods } from "@/state/helpers";
import loading from "@/components/shared/loading";
import userService from "@/helpers/service/user-service";

export default {
	name: "app",
	page: {
		// All subcomponent titles will be injected into this template.
		titleTemplate(title) {
			title = typeof title === "function" ? title(this.$store) : title;
			return title ? `${title} | ${appConfig.title}` : appConfig.title;
		}
	},
	components: {
		loading
	},
	data() {
		return {};
	},
	computed: {...authComputed},
	created() {
		if(this.GET_IS_AUTHENTICATED) this.getUserInfo()
	},
	watch: {
		GET_IS_AUTHENTICATED(newValue, oldValue) {
			if(newValue) this.getUserInfo()
		}
	},
	methods: {
		...authMethods,
		...userMethods,
		async getUserInfo() {
			var result = await userService.GetMeAsync()
			if(result.status == 200) {
				this.ADD_USER(result.data)
			}
			// console.log('getUserInfo',result);
		}
	}
};
</script>

<template>
	<div id="app">
		<RouterView />
		<loading></loading>
	</div>
</template>
